import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';

import { CartComponent } from './cart/cart.component';
import { DudeComponent } from './dude/dude.component';
import { HistoryComponent } from './history/history.component';
import { HomeComponent } from './home/home.component';
import { PostComponent } from './post/post.component';
import { PostsComponent } from './posts/posts.component';
// import { ProductComponent } from './product/product.component';
// import { ProductsComponent } from './products/products.component';
import { TeamComponent } from './team/team.component';
import { VideoComponent } from './video/video.component';
import { VideosComponent } from './videos/videos.component';
import { HistoryPostComponent } from './history-post/history-post.component';

const routes: Routes = [
  { path: '', redirectTo: '/', pathMatch: 'full' },
  { path: '', component: HomeComponent },
  // { path: 'cart', component: CartComponent },
  { path: 'history', component: HistoryComponent },
  { path: 'history/:id', component: HistoryPostComponent },
  // { path: 'posts', component: PostsComponent },
  { path: 'posts', component: PostsComponent },
  { path: 'posts/:id', component: PostComponent },
  // { path: 'products/:id', component: ProductComponent },
  // { path: 'products', component: ProductsComponent },
  { path: 'team', component: TeamComponent },
  { path: 'team/:id', component: DudeComponent },
  { path: 'videos', component: VideosComponent },
  { path: 'videos/:id', component: VideoComponent },
  { path: '**', redirectTo: '/' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }


// WEBPACK FOOTER //
// /tmp/build_fdb7fa8d/src/app/app-routing.module.ts